import { type ReactElement, type ReactNode } from "react"
import Navbar from "src/components/Navbar"
import UserManagementMain from "./Main/UserManagementMain"
import { useLocation } from "react-router-dom"
import Sidebar from "src/components/Sidebar"

export interface UserManagementHomeProps {
        dealerId: string;
        browhistory: string;
        children?: ReactNode;
}

export default function UserManagementHome(props: UserManagementHomeProps): ReactElement {

        const location = useLocation();
        return <>
                <div className="grid grid-cols-[10%_90%] h-full w-full">
                        <div className="h-full">
                                <Sidebar sideBarSelected="UserManagement" />
                        </div>
                        <div className="grid grid-rows-[10%_90%] h-full gap-2 w-full p-2">
                                <div className="w-full">
                                        <Navbar headerType="user" />
                                </div>
                                <div className="grid grid-rows-1 grid-cols-1 w-full h-full">
                                        <UserManagementMain dealerId={props.dealerId} />
                                </div>
                        </div>
                </div>
        </>
}
